/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReportNodeGridDTO } from './ReportNodeGridDTO';
import {
    ReportNodeGridDTOFromJSON,
    ReportNodeGridDTOFromJSONTyped,
    ReportNodeGridDTOToJSON,
} from './ReportNodeGridDTO';

/**
 * 
 * @export
 * @interface ReportNodeDTO
 */
export interface ReportNodeDTO {
    /**
     * 
     * @type {ReportNodeGridDTO}
     * @memberof ReportNodeDTO
     */
    gridProperties?: ReportNodeGridDTO;
    /**
     * 
     * @type {string}
     * @memberof ReportNodeDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ReportNodeDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportNodeDTO
     */
    type: ReportNodeDTOTypeEnum;
}


/**
 * @export
 */
export const ReportNodeDTOTypeEnum = {
    Grid: 'grid'
} as const;
export type ReportNodeDTOTypeEnum = typeof ReportNodeDTOTypeEnum[keyof typeof ReportNodeDTOTypeEnum];


/**
 * Check if a given object implements the ReportNodeDTO interface.
 */
export function instanceOfReportNodeDTO(value: object): value is ReportNodeDTO {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ReportNodeDTOFromJSON(json: any): ReportNodeDTO {
    return ReportNodeDTOFromJSONTyped(json, false);
}

export function ReportNodeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportNodeDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'gridProperties': json['gridProperties'] == null ? undefined : ReportNodeGridDTOFromJSON(json['gridProperties']),
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'type': json['type'],
    };
}

export function ReportNodeDTOToJSON(value?: ReportNodeDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'gridProperties': ReportNodeGridDTOToJSON(value['gridProperties']),
        'id': value['id'],
        'name': value['name'],
        'type': value['type'],
    };
}

